export default __webpack_public_path__ + "static/media/13.9ec8c854.png";